<div class="page-wrapper">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-12">
        <div class="login-card">
          <div>
            <div class="login-main">
              <form class="theme-form" (ngSubmit)="otp()">
                <h4 style="color: #141414; text-align: center;" class="mb-3">
                  {{ curentLang === 'en' ? "OTP" : (curentLang === 'ar' ? "كود التحقق" : "קוד אימות")}}
                </h4>
                <p *ngIf="isLoginOtpMode" class="text-center small" style="color: #141414;">
                  {{ curentLang === 'en'
                    ? "Enter the 6-digit code sent to your phone."
                    : (curentLang === 'ar'
                      ? "أدخل الرمز المكوّن من 6 أرقام المرسل إلى جوالك."
                      : "הזן את הקוד בן 6 הספרות שנשלח לטלפון שלך.")}}
                </p>
                <div *ngIf="!isLoginOtpMode" class="text-center mt-4 mb-4">
                  <span class="reset-password-link">
                    {{ curentLang === 'en' ? "If don't receive OTP ?" : (curentLang === 'ar' ? "إذا لم تستلم رمز التحقق؟" : "אם לא קיבלת קוד אימות?")}}
                    <a class="btn-link text-danger" [routerLink]="'/resend-otp'">
                      {{ curentLang === 'en' ? "Resend" : (curentLang === 'ar' ? "إعادة إرسال" : "שלח מחדש")}}
                    </a>
                  </span>
                </div>
                <div *ngIf="isLoginOtpMode" class="text-center mt-2 mb-2">
                  <span class="reset-password-link">
                    <ng-container *ngIf="resendSecondsLeft && resendSecondsLeft > 0; else canResendTpl">
                      {{ curentLang === 'en'
                        ? ('You can resend the code in ' + resendSecondsLeft + ' seconds.')
                        : (curentLang === 'ar'
                          ? ('يمكنك إعادة إرسال الكود بعد ' + resendSecondsLeft + ' ثانية.')
                          : ('תוכל לשלוח את הקוד שוב בעוד ' + resendSecondsLeft + ' שניות.')) }}
                    </ng-container>
                    <ng-template #canResendTpl>
                      {{ curentLang === 'en'
                        ? "If you didn't receive the code, you can resend it."
                        : (curentLang === 'ar'
                          ? "إذا لم تستلم رمز التحقق، يمكنك إعادة إرسال الكود."
                          : "אם לא קיבלת את הקוד, תוכל לשלוח אותו שוב.")}}
                    </ng-template>
                    <button type="button"
                            class="btn btn-link text-danger p-0 ms-1"
                            (click)="resendLoginOtp()"
                            [disabled]="resendDisabled">
                      {{ curentLang === 'en'
                        ? "Resend code"
                        : (curentLang === 'ar' ? "إعادة إرسال الكود" : "שלח קוד מחדש")}}
                    </button>
                  </span>
                </div>
                <div *ngIf="isLoginOtpMode" class="text-center mb-2">
                  <a class="btn-link text-danger" [routerLink]="['/login']">
                    {{ curentLang === 'en'
                      ? "Back to login"
                      : (curentLang === 'ar' ? "العودة لتسجيل الدخول" : "חזור להתחברות")}}
                  </a>
                </div>
                <label class="col-form-label pt-0 m-auto text-center" style="color: #141414;">
                  {{ curentLang === 'en' ? "Enter Verification Code" : (curentLang === 'ar' ? "ادخل رمز التحقق" : "הזן קוד אימות")}}
                </label>
                <div class="form-group">
                  <div class="row">
                    <div class="col">
                      <input class="form-control text-center opt-text"
                             type="text"
                             [placeholder]="otpRequiredLength === 6 ? '000000' : '0000'"
                             [maxlength]="otpRequiredLength"
                             [(ngModel)]="otpCode"
                             [attr.autocomplete]="isLoginOtpMode ? 'one-time-code' : 'off'"
                             inputmode="numeric"
                             pattern="[0-9]*"
                             name="otpCode"
                             (input)="onOtpInput()"
                             (keypress)="isNumber($event)">
                    </div>
                  </div>
                </div>
                <div *ngIf="isLoginOtpMode" class="trusted-device-option">
                  <label class="trusted-device-checkbox-label">
                    <input type="checkbox"
                           [(ngModel)]="addToTrustedDevices"
                           name="addToTrustedDevices"
                           class="form-check-input">
                    <span class="trusted-device-checkbox-text">{{ 'TrustedDevices.trustThisDeviceCheckbox' | translate }}</span>
                  </label>
                  <p class="trusted-device-duration">{{ 'TrustedDevices.trustDuration' | translate: { days: trustDurationDays } }}</p>
                </div>
                <button [disabled]="!otpCode || otpCode.length !== otpRequiredLength"
                        class="btn d-block w-100 m-t-10"
                        style="background-color: #141414; color: #fff;"
                        type="submit">
                  {{ curentLang === 'en' ? "Submit" : (curentLang === 'ar' ? "إرسال" : "שלח")}}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
